"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { OSANO_UI_TARGET_ID } from "../osanoConstants";
type OsanoGlobal = {
  cm?: {
    render?: () => void;
  };
};

/**
 * Stable mount slot + post-hydration trigger for the Osano CMP UI.
 *
 * Pair with `<OsanoConsentScript />` in `<head>` (which sets
 * `data-osano-load-mode="event"`). Blocking still runs from the head script;
 * this only mounts the visible UI after React has hydrated.
 *
 * @see https://developers.osano.com/cmp/javascript-api/developer-documentation-consent-javascript-api
 */
export function OsanoConsentUi() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div id={OSANO_UI_TARGET_ID} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp() {
  (window as Window & {
    Osano?: OsanoGlobal;
  }).Osano?.cm?.render?.();
}